function XcomIcon(): JSX.Element {
    return (
        <svg
            width="20"
            height="15.5556"
            viewBox="0 0 20 15.5556"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M 14.4444,5.5556 C 14.4444,2.4861 11.2118,0 7.2222,0 3.2326,0 0,2.4861 0,5.5556 0,6.7465 0.48958,7.8437 1.31944,8.75 0.85417,9.7986 0.08681,10.6319 0.07639,10.6424 0,10.7222 -0.02083,10.8403 0.02431,10.9444 c 0.04513,0.1042 0.14236,0.1667 0.25347,0.1667 1.27083,0 2.32291,-0.4271 3.07982,-0.868 1.1181,0.5451 2.441,0.868 3.8646,0.868 3.9896,0 7.2222,-2.4861 7.2222,-5.5555 z m 4.2362,7.6388 C 19.5104,12.2917 20,11.191 20,10 20,7.6771 18.1424,5.6875 15.5104,4.8576 c 0.0313,0.2292 0.0452,0.4618 0.0452,0.698 0,3.677 -3.7396,6.6666 -8.3334,6.6666 -0.375,0 -0.7396,-0.0278 -1.1007,-0.066 1.0938,1.9966 3.6632,3.3994 6.6563,3.3994 1.4236,0 2.7465,-0.3195 3.8646,-0.8681 0.7569,0.441 1.809,0.8681 3.0798,0.8681 0.1111,0 0.2118,-0.066 0.2535,-0.1667 0.0451,-0.1007 0.0243,-0.2188 -0.0521,-0.3021 -0.0104,-0.0104 -0.7778,-0.8403 -1.243,-1.8924 z"
            />
        </svg>
    );
}

export { XcomIcon };
